import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmployerDashboardComponent } from './employer-dashboard.component';
import { EmployerOverviewComponent } from './employer-overview/employer-overview.component';
import { EmployerSidebarComponent } from './employer-sidebar/employer-sidebar.component';
import { RouterModule } from '@angular/router';
import { PostJobComponent } from './post-job/post-job.component';
import { ViewJobComponent } from './view-job/view-job.component';
import { MatTabsModule, MatInputModule, MatFormFieldModule, MatSnackBarModule, MatRadioModule, MatSelectModule, MatAutocompleteModule, MatCardModule, MatCheckboxModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { TagInputModule } from 'ngx-chips';
import { SharedModule } from 'src/app/shared/shared.module';
import { DetailedViewComponent } from './view-job/detailed-view/detailed-view.component';
import { CandidateDetailsComponent } from './view-job/detailed-view/candidate-details/candidate-details.component';
import {
  NzTabsModule, NzSkeletonModule, NzEmptyModule, NzSelectModule, NzSliderModule, NzInputModule, NzCheckboxModule, NzDropDownModule,
  NzIconModule, NzButtonModule, NzMessageModule, NzPaginationModule, NzPageHeaderModule, NzDescriptionsModule, NzTagModule, NzStatisticModule, NzLayoutModule, NzGridModule, NzCardModule, NzBadgeModule, NgZorroAntdModule
} from 'ng-zorro-antd';
import { EmployerEditProfileComponent } from './employer-edit-profile/employer-edit-profile.component';
import { CreateEmployerProfileComponent } from '../create-employer-profile/create-employer-profile.component';


@NgModule({
  declarations: [EmployerDashboardComponent, EmployerOverviewComponent, EmployerSidebarComponent, PostJobComponent, ViewJobComponent, DetailedViewComponent, CandidateDetailsComponent, EmployerEditProfileComponent,CreateEmployerProfileComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatTabsModule,
    FormsModule,
    MatInputModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSnackBarModule,
    MatRadioModule,
    MatSelectModule,
    MatCheckboxModule,
    AngularEditorModule,
    MatAutocompleteModule,
    TagInputModule,
    MatCardModule,
    SharedModule,
    NzTabsModule,
    NzSkeletonModule,
    NzEmptyModule,
    NzSelectModule,
    NzSliderModule,
    NzInputModule,
    NzCheckboxModule,
    NzDropDownModule,
    NzIconModule,
    NzButtonModule,
    NzMessageModule,
    NzPaginationModule,
    NzPageHeaderModule,
    NzDescriptionsModule,
    NzTagModule,
    NzStatisticModule,
    NzLayoutModule,
    NzGridModule,
    NzCardModule,
    NzBadgeModule,
    NgZorroAntdModule
  ],
  entryComponents: [
    CreateEmployerProfileComponent
  ]
})
export class EmployerDashboardModule { }
